import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PBIService } from '../pbi/pbi.service';
import { SessionStorageService } from '../session-storage/session-storage.service';
import { LoginService} from '../login/login.service'

@Injectable()
export class AuthenticationService {

  constructor(
    private router: Router,
    private sessionStorage: SessionStorageService,
    private loginService: LoginService
  ) { }

  isLoggedIn() {
    if (this.sessionStorage.getItem('token')) {
      return true;
    }
    return false;
  }

  isAdmin() {
    return this.sessionStorage.getItem('extraMenu') === "1";
  }

  getName() {
    return this.sessionStorage.getItem('name');
  }

  updateName(name: string) {
    this.sessionStorage.setItem('name', name);
  }

  getEmail() {
    return this.sessionStorage.getItem('email');
  }

  logout() {
    this.sessionStorage.removeItem('token');
    this.sessionStorage.removeItem('name');
    this.sessionStorage.removeItem('email');
    this.sessionStorage.removeItem('workspaces');
    this.sessionStorage.removeItem('extraMenu');
  }

  login({email,name, token, expireIn, isAdmin,language,refreshToken}: { email: string, name: string, token: string, expireIn: string, isAdmin?: boolean, language:string,refreshToken:string}) {
    this.sessionStorage.setItemWithExpiration('email', email, expireIn);
    this.sessionStorage.setItemWithExpiration('name', name, expireIn);
    this.sessionStorage.setItemWithExpiration('token', token, expireIn);
    this.sessionStorage.setItemWithExpiration('refreshToken', refreshToken,parseInt(expireIn)*24);
    this.sessionStorage.setItemWithExpiration('expireIn', expireIn,parseInt(expireIn)*24);
    this.sessionStorage.setItemWithExpiration('extraMenu', isAdmin ? "1" : "0", expireIn);
    this.sessionStorage.setItemWithExpiration('language', language ? language : "en", expireIn);
  }

  async renew(){
    console.log('renovando token')
    var a = await this.loginService.renew();
    this.sessionStorage.setItemWithExpiration('token', a.token, a.expireIn);
    this.sessionStorage.setItemWithExpiration('name', a.name, a.expireIn);
    this.sessionStorage.setItemWithExpiration('token', a.token, a.expireIn);
    this.sessionStorage.setItemWithExpiration('expireIn', a.expireIn,parseInt(a.expireIn)*24);
    this.sessionStorage.setItemWithExpiration('language', a.language ? a.language : "en", a.expireIn);
  }
}
